export default __webpack_public_path__ + "static/media/268.dd89f2b4.jpg";